/*
	Advanced search is an optional search section delivering further fields to the user.
*/


Advanced_search = {
	p_advanced_id : '.property-search .advanced'
	,
	p_advanced : {}
	,
	p_toggle_id : '.toggle'
	,
	p_toggle : {}
	,
	p_toggle_options : {}
	,
	p_fields_id : '.fields-wrapper'
	,
	p_fields : {}
	,
	init : function()
	{
		// Find elements.
		Advanced_search.p_advanced = jQuery(Advanced_search.p_advanced_id);
		Advanced_search.p_toggle = jQuery(Advanced_search.p_toggle_id);
		Advanced_search.p_fields = jQuery(Advanced_search.p_fields_id);
		
		// Find attributes.
		var open_label = Advanced_search.p_toggle.attr('data-open-label');
		var closed_label = Advanced_search.p_toggle.attr('data-closed-label');
		
		// Setup toggle parameters.
		Advanced_search.p_toggle_options = {
			'closed': {
				'label': closed_label,
			}
			,
			'open': {
				'label': open_label,
			}
		};
		
		// Initialise UI.
		Advanced_search.setup_ui();
	}
	,
	is_open : function()
	{
		return( Advanced_search.p_advanced.hasClass('open') );
	}
	,
	setup_ui : function()
	{
		// Setup toggle element to update UI on click.
		Advanced_search.p_toggle.each(function(){
			
			jQuery(this).click(function(){
				Advanced_search.toggle();
			})
			
		});
		
		// Initialise UI.
		Advanced_search.update_ui( Advanced_search.is_open() );
	}
	,
	update_ui : function( pm_open )
	{
		// Find element which tracks open state of advanced seach page-to-page.
		var advanced_open_tracker = jQuery('input[name="advanced_open"]');
		
		// Set UI to open or closed state.
		if( pm_open )
		{
			// Track via a class.
			//Advanced_search.p_advanced.addClass('open');
			
			// Reset fields.
			Advanced_search.p_fields.slideDown('fast',function(){
				
				// Track via a class.
				Advanced_search.p_advanced.addClass('open');
				
				// Update toggle element.
				Advanced_search.p_toggle.html( Advanced_search.p_toggle_options.open.label );
			
				// Update element which tracks open state of advanced seach page-to-page.
				advanced_open_tracker.val('open');
				
			});
			
			// Update toggle element.
			//Advanced_search.p_toggle.html( Advanced_search.p_toggle_options.open.label );
			
			// Update element which tracks open state of advanced seach page-to-page.
			//advanced_open_tracker.val('open');
		}
		else
		{
			// Track via a class.
			//Advanced_search.p_advanced.removeClass('open');
			
			// Reset fields.
			Advanced_search.p_fields.slideUp('fast',function(){
				
				// Track via a class.
				Advanced_search.p_advanced.removeClass('open');
				
				// Update toggle element.
				Advanced_search.p_toggle.html( Advanced_search.p_toggle_options.closed.label );
			
				// Update element which tracks open state of advanced seach page-to-page.
				advanced_open_tracker.val('closed');
				
			});
			
			// Update toggle element.
			//Advanced_search.p_toggle.html( Advanced_search.p_toggle_options.closed.label );
			
			// Update element which tracks open state of advanced seach page-to-page.
			//advanced_open_tracker.val('closed');
		}
	}
	,
	toggle : function()
	{
		// Run UI update opposite to the current open state.
		Advanced_search.update_ui( !Advanced_search.is_open() );
	}
};


jQuery(document).ready(function(jQuery){
	
	///Property_search.init();
	
	// Advanced search is an optional search section delivering further fields to the user.
	Advanced_search.init();
	
	//Feature details are Sherlock programmable features designated to categorise properties.
	///Feature_details.init();
	
	// Price range utilises a price slider to consolidate minimum and maximum price values on a search.
	///Price_range.init();
	
	///Property_sort.init();

});

